module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aso-identidade-step"
  }, [(!_vm.cadastroExistente && !_vm.possuiDadosCerebro) ? [_c('h2', {
    staticClass: "aso-identidade-step__title"
  }, [_vm._v("Confirme sua identidade.")]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__text"
  }, [_vm._v("Informe seus dados para confirmar na consulta.")]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Nome completo")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "placeholder": "Nome completo",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.nome
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:nome', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "14",
      "placeholder": "000.000.000-00",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.cpf
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:cpf', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.sexo
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:sexo', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Feminino")])])]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "date",
      "placeholder": "dd/mm/aaaa",
      "disabled": _vm.busy
    },
    domProps: {
      "value": _vm.dataNascimento
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:dataNascimento', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Validando...' : 'Continuar') + "\n    ")])] : [_c('h2', {
    staticClass: "aso-identidade-step__title"
  }, [_vm._v(_vm._s(_vm.cadastroExistente ? 'Bem vindo de volta!' : 'Identificamos seus dados!'))]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__text"
  }, [_vm._v("Confira seus dados cadastrados. Caso necessário, habilite a edição para atualizá-los.")]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__toggle-row"
  }, [_c('label', {
    staticClass: "aso-identidade-step__switch-label"
  }, [_c('span', {
    staticClass: "aso-identidade-step__switch-text"
  }, [_vm._v("Deseja editar suas informações? "), _c('strong', [_vm._v(_vm._s(_vm.editavel ? 'Sim' : 'Não'))])]), _vm._v(" "), _c('span', {
    staticClass: "aso-identidade-step__switch",
    class: {
      'aso-identidade-step__switch--on': _vm.editavel
    },
    attrs: {
      "role": "switch",
      "aria-checked": String(_vm.editavel),
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      },
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
        !_vm.busy && _vm.$emit('toggle-edit', !_vm.editavel)
      }]
    }
  }, [_c('span', {
    staticClass: "aso-identidade-step__switch-thumb"
  })])])]), _vm._v(" "), (_vm.editavel) ? _c('div', {
    staticClass: "aso-identidade-step__warning-card"
  }, [_c('div', {
    staticClass: "aso-identidade-step__warning-header"
  }, [_c('svg', {
    staticClass: "aso-identidade-step__warning-icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12 2L1 21h22L12 2z",
      "fill": "#ffc107",
      "stroke": "#e6ac00",
      "stroke-width": "1"
    }
  }), _vm._v(" "), _c('text', {
    attrs: {
      "x": "12",
      "y": "18",
      "text-anchor": "middle",
      "font-size": "14",
      "font-weight": "bold",
      "fill": "#5a4000"
    }
  }, [_vm._v("!")])]), _vm._v(" "), _c('p', {
    staticClass: "aso-identidade-step__warning-text"
  }, [_vm._v("Para atualizar o cadastro, todos os campos precisam ser editados:")])]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Nome completo")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "disabled": !_vm.editavel || _vm.busy,
      "placeholder": "Nome completo"
    },
    domProps: {
      "value": _vm.editavel ? _vm.nome : _vm.maskedNome
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:nome', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("CPF")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "text",
      "inputmode": "numeric",
      "maxlength": "14",
      "disabled": !_vm.editavel || _vm.busy,
      "placeholder": "000.000.000-00"
    },
    domProps: {
      "value": _vm.editavel ? _vm.cpf : _vm.maskedCpf
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:cpf', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "disabled": !_vm.editavel || _vm.busy
    },
    domProps: {
      "value": _vm.sexo
    },
    on: {
      "change": function($event) {
        return _vm.$emit('update:sexo', $event.target.value)
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "M"
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "F"
    }
  }, [_vm._v("Feminino")])])]), _vm._v(" "), _c('div', {
    staticClass: "aso-identidade-step__field"
  }, [_c('label', {
    staticClass: "aso-identidade-step__field-label"
  }, [_vm._v("Data de nascimento")]), _vm._v(" "), _c('input', {
    staticClass: "aso-identidade-step__input",
    attrs: {
      "type": "date",
      "disabled": !_vm.editavel || _vm.busy
    },
    domProps: {
      "value": _vm.dataNascimento
    },
    on: {
      "input": function($event) {
        return _vm.$emit('update:dataNascimento', $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "aso-identidade-step__button aso-flow-button aso-flow-button--loud aso-flow-button--full",
    attrs: {
      "type": "button",
      "disabled": _vm.busy
    },
    on: {
      "click": function($event) {
        return _vm.$emit('validate')
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.busy ? 'Salvando...' : (_vm.editavel ? 'Salvar e continuar' : 'Continuar')) + "\n    ")])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "aso-identidade-step__warning-list"
  }, [_c('li', [_vm._v("Nome")]), _vm._v(" "), _c('li', [_vm._v("CPF")]), _vm._v(" "), _c('li', [_vm._v("Sexo")]), _vm._v(" "), _c('li', [_vm._v("Data de Nascimento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-516f00f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/funcionario/aso/assinar/AsoValidarIdentidadeStep.vue
// module id = 1481
// module chunks = 45